import React, { useState, useContext, useEffect, useRef } from 'react';
import { ForwardFittingContext } from "../../ForewardFitting/ForwardFittingContext";
import { uploadimagetoserver } from "../../../Api/contact";
import { API_URL } from "../../../Api/config";
import Loader2 from '../Loader/Loader2';

const VideoUpload2 = ({ step, onfilechange, borderClass, filmswingvalidate,remotefittingdatavideos }) => {

    const { updateremotefittingfile, remotefittingimage } = useContext(ForwardFittingContext);   
    const videoRef = useRef(null);
    const [imageURL, setImageURL] = useState(remotefittingdatavideos);
    const [videoURL, setVideoURL] = useState(`${API_URL}remotefittingvideo/${remotefittingdatavideos}`);
    const [isLoading, setIsLoading] = useState(false);
 
    console.log("amineshvermaji",`${step}.swing2`);
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        updateremotefittingfile(`${step}.swing2`, file);
        console.log("amineshvermaji",`${step}.swing2`, file);
        saveimagetoserver(file);
    };

    const saveimagetoserver = (file) => {
        setIsLoading(true);
        const formData = new FormData();
        formData.append('image', file);

        uploadimagetoserver(formData).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                alert(res.data.data[0].detail);
            } else {
                const filename = res.data.data;
                onfilechange(filename);
                localStorage.setItem("secondfilename", filename);
                setVideoURL(`${API_URL}remotefittingvideo/${filename}`);
                setImageURL(filename);
                setIsLoading(false);
            }

        }).catch((error) => {
            console.log("error", error);
        });

    }



    useEffect(() => {
        if (videoRef.current) {
            const video = videoRef.current;
            const loadVideoMetadata = () => {
                // Attempt to seek to a frame a little after the start to show as preview
                video.currentTime = 0.5; // Adjust this value as needed
            };
            video.addEventListener('loadedmetadata', loadVideoMetadata);
            return () => {
                video.removeEventListener('loadedmetadata', loadVideoMetadata);
            };
        }
    }, [videoURL]);

    

 


    return (
        <>
            {
                isLoading ? (
                    <div className="loading" >
                        <Loader2 />
                    </div >
                ) : (
                    <>
                        <div className="card-video">
                            <div className={`${borderClass ? borderClass : 'drop_box'}`}>
                                <input
                                    type="file"
                                    accept=".mp4,.avi,.mkv"
                                    id={`${step}.swing2.fileID`}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                />
                                {imageURL != undefined  && (
                                    <div className="form">
                                        <video
                                            ref={videoRef}
                                            playsInline
                                            autoPlay={false}
                                            key={videoURL}
                                            style={{ width: '100%', position: "absolute", top: "0", left: "0", height: "100%", borderRadius: "1.5rem", }}
                                            controls
                                            preload="metadata">
                                                <source src={videoURL + ''} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                )}  
                                {
                                    filmswingvalidate === false && (
                                        <div className='custom-upload-btn'>
                                            <button className="btn-upload" onClick={() => document.getElementById(`${step}.swing2.fileID`).click()}>
                                                <img src={require('../../../assets/images/photo-camera.png')} alt="upload" />
                                            </button>
                                        </div>
                                    )
                                }

                            </div>
                        </div>
                    </>
                )
            }
        </>
    );
};

export default VideoUpload2;